var bLazy = new Blazy();

var digistormWeb = {

	maps: function() {
		$('.event-single [data-map]').each(function() {
			var mapEl = $(this);
			var position = {
				lat: parseFloat(mapEl.data('lat')),
				lng: parseFloat(mapEl.data('lng'))
			};
	
			var config = {
				center: position,
				zoom: parseInt(mapEl.data('zoom'), 10)
			}
	
			if (mapEl.is('[data-directions]')) {
				config.disableDefaultUI = true;
				mapEl.click(function () {
					window.open('https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(position.lat + ',' + position.lng));
				});
			}
	
			var map = new google.maps.Map(mapEl[0], config);
	
			var marker = new google.maps.Marker({
			  position: position,
			  map: map
			});
		});
	},
}





$(document).ready(function(){
	//mute youtube banner
	$('iframe#banner-youtube').load(function(){
		var bannerYT = new YT.Player('banner-youtube', {
			events: {
				'onReady': function(){bannerYT.setVolume(0);}
			}
		});
	});

	$('main.main .banner .video-close').click(function() {
		$('main.main').addClass('video-closed');

		// pause current video
		var video = $('main.main .banner .video-wrap iframe.vimeo');
		if(video.length) new Vimeo.Player(video).pause();

		var ytvideo = $('main.main .banner .video-wrap iframe.ytplayer');
		if(ytvideo.length && ytvideo[0].ytplayer) ytvideo[0].ytplayer.pauseVideo();
	});

	if ($('#history').length) {
		$('.history-item-point').click(function(){
			var $line = $(this).closest('.history-line');
			var left = $(this).closest('.history-item').offset().left;
			var scroll = $line.scrollLeft();
			var width = $( window ).width() / 2;
			$line.stop().animate({scrollLeft: left + scroll - width + 100}, 500);
		});
	}

	// SVG Map resizer
	var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
	var eventer = window[eventMethod];
	var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
	var firstLoad = true;
	eventer(messageEvent, function (e) {
		if (e.data == 'svgMapLoaded') {
			if (firstLoad) {
				firstLoad = false;
			} else {
				// Scroll to top if iframe reloads
				$(window).scrollTop($('#map-svg').offset().top - 100);
			}
		} else {
			if (typeof e.data === 'string' || e.data instanceof String) {
				var matches = e.data.match(/^svgMapHeight=(\d+)$/);
				if (matches) {
					$('#map_svg').css('height', (parseInt(matches[1])) + 'px');
				}
			}
		}
	});



});

function stories() {
	var _self = this;
	$('[data-stories-load]').each(function() {
		var storiesUrl = $(this).attr('data-stories-url');
		var block = $('.news-items', this);
		var limit = 6;
		var url = $(this).attr("data-stories-url");
		var category = $(this).data("stories-category");
		var url = "/api/stories.php?url="+url;
		$.ajax({
			type: 'GET',
			url: url,
			data: {
				start: Math.floor(Date.now() / 1000),
				limit: limit,
				category: category,
			},
			dataType: 'json',
			success: function (data) {

				var storiesClone = $('<a class="news-item" href="#" target="_blank"> <span class="big-circle p-related"><img class="object-cover object-center border-50"> <span class="overlay"> Read more </span> </span> <span class="news-content"> <span class="news-title"> # </span> <span class="news-author"> # </span> <span class="news-summary"> # </span> </span> </a>');

				$.each(data.result,function(i,v){
					if (i >= limit) {
						return false;
					}
					var newClone = storiesClone.clone(true);
					var txt = v.description;
					newClone.find('.news-summary').text(txt.substring(0,200) + '...');
					newClone.attr("href", v.url);
					newClone.find('.big-circle').css('background-image', 'url("' + v.featured_image + '")');
					newClone.find('img.object-cover').attr({
						'src': v.featured_image,
						'alt': v.title
					});
					newClone.find('.news-title').text(v.title);
					newClone.find('.news-author').text(v.author);
					block.append(newClone);
				});

				$('#loading-image').hide();

				$('.news-items').slick({
			    	dots: false,
			    	arrows: false,
			    	slidesToShow: 3,
			    	responsive: [
			    		{
			    			breakpoint: 768,
			    			settings: {
			    				dots: true,
			    				slidesToShow: 1
			    			}
			    		}
			    	]
			    });

			}
		})
		.fail(function () {
			$('#loading-image').hide();
			block.html('<p>Stories coming soon</p>');
		})
		.always(function () {
			block.addClass('stories-loaded');
		});
	})
}

$(document).ready(function(){
	stories();
});

$(document).ready(function(){

	if ($('.slideshow-container').length) {
		$('.slideshow-container').slick({
			autoplay: true,
			dots: true,
			slidesToShow: 1,
		});
		$('.slideshow-container').find(".testimonial-image").addClass("animated");
		$('.slideshow-container').on("beforeChange", function (event, slick, currentSlide, nextSlide) {
			$('.slideshow-container').find(".testimonial-image").removeClass("animated");
			setTimeout(function () {
				$('.slideshow-container').find(".testimonial-image").addClass("animated");
			}, 400);
		});

	}
});


//slides slick
$(document).ready(function(){
  $('.slides').each(function(){
  	var speed = $(this).attr('data-speed');
  	if(!speed || speed == 0){
	  	$(this).slick({
	  	arrows: false,
		autoplay: false
	  });
  	}else{
	  	$(this).slick({
		  	arrows: false,
		  	autoplay: true,
			autoplaySpeed: speed
		 });
	  }
	});
});


// Custom lazy loading for Slick sliders when using background images
var loadBackgroundImages = function(slides) {
    $(slides).filter('[data-lazy]').each(function () {
        // set background image and remove attribute
        $(this).css('background-image', 'url("' + $(this).attr('data-lazy') + '")').removeAttr('data-lazy');
    });
}
// Handle init and slide change events
$('.slides')
    .on('beforeChange', function(event, slick, currentSlide, nextSlide){
        // load the image for the next slide after the upcoming slide
        var directionForwards = currentSlide === nextSlide - 1;
        loadBackgroundImages(slick.$slides.get(directionForwards ? nextSlide + 1 : nextSlide));
    })
    .on('init', function(event, slick) {
        // load initial and second slide
        loadBackgroundImages(slick.$slides.slice(0, 2));
        // load cloned slides (these slides ensure a smooth transition when you reach the end of the slides in either direction)
        loadBackgroundImages($('.slick-cloned', this));
    });

//mosaic slides slick
$(document).ready(function(){

  $('.mosaic-slides').each(function(){
  	var speed = $(this).attr('data-speed');
  	if(!speed || speed == 0){
	  	$(this).slick({
	  	arrows: false,
	  	dots: true,
	  	autoplay: false
	  });
  	}else{
	  	$(this).slick({
		  	arrows: false,
		  	dots: true,
		  	autoplay: true,
		  	autoplaySpeed: speed
		 });
	  }
	});
});

//24 hours middle slides slick
$(document).ready(function(){

	$('.hours-slides').on('init reinit', function(event, slick){

		draw24lines();



		var currentSlide = $(event.currentTarget).closest('.hours-slides').attr('data-initial-slide')

		slick.slickGoTo(currentSlide);

		//var currentSlide = slick.currentTarget;

		if(currentSlide == 0){ 							//if first slide, remove  left margin
			$(event.currentTarget).find(".slick-track").animate({
				marginLeft: '-12.5%'
			}, 500);

			$(this).closest('.hours-slides').addClass('scrolled-left');

		}else if(currentSlide == slick.slideCount - 1){	//if last slide remove right margin
			$(event.currentTarget).find(".slick-track").animate({
				marginLeft: '12.5%'
			}, 500);

			$(this).closest('.hours-slides').addClass('scrolled-right');

		}else{
			$(event.currentTarget).find(".slick-track").animate({
				marginLeft: '0%'
			}, 500);

			$(this).closest('.hours-slides').removeClass('scrolled-right');
			$(this).closest('.hours-slides').removeClass('scrolled-left');
		}
	});

	$('.hours-slides').on('beforeChange', function(event, slick, currentSlide, nextSlide){

		// pause current video
		var video = $(slick.$slides.get(currentSlide)).find('.slide-video iframe.vimeo');
		if(video.length) new Vimeo.Player(video).pause();

		var ytvideo = $(slick.$slides.get(currentSlide)).find('.slide-video iframe.ytplayer')
		if(ytvideo.length && ytvideo[0].ytplayer) ytvideo[0].ytplayer.pauseVideo();


		if(nextSlide == 0){ 							//if first slide, remove  left margin
			$(event.currentTarget).find(".slick-track").animate({
				marginLeft: '-12.5%'



			}, 500);

			$(this).closest('.hours-slides').addClass('scrolled-left');

		}else if(nextSlide == slick.slideCount - 1){	//if last slide remove right margin
			$(event.currentTarget).find(".slick-track").animate({
				marginLeft: '12.5%'



			}, 500);


			$(this).closest('.hours-slides').addClass('scrolled-right');

		}else{
			$(event.currentTarget).find(".slick-track").animate({
				marginLeft: '0%'
			}, 500);

			$(this).closest('.hours-slides').removeClass('scrolled-right');
			$(this).closest('.hours-slides').removeClass('scrolled-left');
		}
	});


  $('.hours-slides').slick({
  	arrows: false,
  	dots: false,
  	//autoplay: true,
  	autoplaySpeed: 1000,
  	slidesToShow: 1,
  	centerMode: true,
  	centerPadding: '10%',
  	focusOnSelect: true,
  	infinite: false,
  	responsive: [
  		{
  			breakpoint: 992,
  			settings: {
  				centerPadding: '0%',
  				dots: true
  			}
  		}
  	]
  });


});


//big photos slick
$(document).ready(function(){
  $('.big-photos').slick({
  	arrows: true,
  	autoplay: false,
  	// adaptiveHeight: true,
  	lazyLoad: 'ondemand',
  	prevArrow: '<button class="slick-arrow slick-prev"><svg class="circle circle-arrow arrow-left" viewbox="0 0 32 32"><use xlink:href="#arrow"></use></svg></button>',
  	nextArrow: '<button class="slick-arrow slick-next"><svg class="circle circle-arrow" viewbox="0 0 32 32"><use xlink:href="#arrow"></use></svg></button>'
  });
	$('.big-photos').on('init afterChange lazyLoaded', function(){
		var heightActiveSlider = $('.big-photos .slick-slide.slick-active').height();
		$('.big-photos .slick-list').animate({
			height: heightActiveSlider
		});
		// $('.big-photos .slick-slide.slick-active img').animate({
		// 	height: heightActiveSlider
		// });
	});
  $('.big-photos').on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){

  	if(event.type == "beforeChange"){
  		currentSlide = nextSlide;
  	}

  	currentSlide = currentSlide?currentSlide:0;

  	$(this).closest('.gallery').find('.counter').text((currentSlide)+1 + " of " + slick.slideCount);

  	$(this).closest('.gallery').find('.thumbnails .thumbnail.big-selected').removeClass('big-selected');
  	var thumbnailSelector = '.thumbnails .thumbnail[data-slick-index="'+(currentSlide)+'"]';
  	if(currentSlide >= slick.slideCount - 5){
  		thumbnailSelector += ', .thumbnails .thumbnail[data-slick-index="'+(currentSlide - slick.slideCount)+'"]';
  	}
  	if(currentSlide < 5){
  		thumbnailSelector += ', .thumbnails .thumbnail[data-slick-index="'+(slick.slideCount + currentSlide)+'"]';
  	}
  	$(this).closest('.gallery').find(thumbnailSelector).addClass('big-selected');

  });
});

//thumbnails slick
$(document).ready(function(){
  $('.thumbnails').slick({
  	arrows: true,
  	autoplay: false,
  	slidesToShow: 5,
  	slidesToScroll: 5,
  	prevArrow: '<button class="slick-arrow slick-prev"><svg class="circle circle-arrow arrow-left" viewbox="0 0 32 32"><use xlink:href="#arrow"></use></svg></button>',
  	nextArrow: '<button class="slick-arrow slick-next"><svg class="circle circle-arrow" viewbox="0 0 32 32"><use xlink:href="#arrow"></use></svg></button>'
  });
});

$('.thumbnails').on('click', '.slick-slide', function(event){
	$(this).closest('.gallery').find('.big-photos').slick('slickGoTo', event.target.dataset.slickIndex);
});


// get alerts
$(document).ready(function(){

	var alertid;
	var alerts;
	var dismissed;
	var currentalert;

	$.ajax("/notices").done(
		function(result){
			// result = JSON.parse(result);

			if(result.length){

				alerts = result;
				dismissed = Cookies.getJSON('dismissed');
				if(dismissed == null){
					dismissed = [];
				}
				alertid = result[0]['id'];
				currentalert = 0;

				getNextAlert();
			}
		});


	function getNextAlert(){

		var isdismissed = true;
		while(isdismissed && currentalert < alerts.length){

			isdismissed = false;
			alertid = alerts[currentalert]['id'];

			for(var j = 0; j < dismissed.length; j++){
				if (dismissed[j] == alertid){
					isdismissed = true;
				}
			}
			if(!isdismissed){
				$(".navbar-alert .alert-content").html("<div class='alert-title'>" + alerts[currentalert]['title']+ "</div><div class='alert-message'>" + alerts[currentalert]['body'] + "</div>");

				$(".navbar-alert").addClass("active");
				$('main.main').addClass('alert-active');
			}else{
				currentalert++;
			}
		}
	}


	$('.navbar-alert .dismiss-alert').click(function(){
		$(".navbar-alert").removeClass("active");
		$('main.main').removeClass('alert-active');
		dismissed.push(alertid);
		Cookies.set('dismissed', dismissed);
		window.setTimeout(getNextAlert, 500);
	});
});


//initialise calendar
if ($("#calendar").length > 0) {
    $("#calendar").fullCalendar({
        events: {
            url: "/events",
            type: "GET",
            data: {
            },
            error: function() {

            }
        },
        displayEventTime: true,
        timezone: "Australia/Brisbane",
        header: {
            left: 'prev, next, today',
            center: 'title',
            right: 'month,basicWeek,basicDay'
        },
        buttonText: {
        	prev: '<',
        	next: '>'
        },
        editable: false,
        columnFormat: {
            month: 'ddd',   // Mon
            week: 'ddd d/M',  // Mon 31/12
            day: 'dddd d/M'   // Monday 31/12
        },
        timeFormat: 'h(:mm)tt',
        eventClick: function(event) {

            // add modal window
            $('body').append(event.content);

            $('#e_'+event.id).addClass('modal-active');

            return false;

        },
        loading: function(bool) {
            if (bool) {
                $('#calendar .loader').addClass('active');
            } else {
                $('#calendar .loader').removeClass('active');
            }
        }

    });
}




// new mobile calendar

	var eventsClone = $('<div class="mobile-event"><div class="mobile-details"><div class="mobile-title"></div><div class="mobile-time"></div></div></div>');
	var dayClone = $('<div class="mobile-day-marker"><div class="mobile-weekday"></div><div class="mobile-date"><div class="mobile-day"></div><div class="mobile-month"></div></div></div>')
	var activeDate;
	var currentRequest;
	var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

	function initMobileCalendar(){

		var mobileCal = $('#calendar-mobile');
		mobileCal.html('<div class="controls"><button class="mobile-prev-week">←</button><div class="mobile-current-week"></div><button class="mobile-next-week">→</button></div><div class="mobile-events"></div>');


		$('#calendar-mobile .mobile-next-week').click(function(){
			incrementWeeks(1);
		});

		$('#calendar-mobile .mobile-prev-week').click(function(){
			incrementWeeks(-1);
		});


		var sunday = sundaySingapore();
		setActiveDate(sunday);
		getWeeklyEvents(sunday);
	}


	function sundaySingapore(){
		// returns current date in singapore (00:00)

		// current time
		var today = new Date();

		// singapore time zone offset in ms
		var singaporeOffset = (+8*60*60*1000);

		var singaporeToday = new Date();
		// manipulate utc time to represent singapore timezone (utc = +8)
		singaporeToday.setTime(today.getTime() + singaporeOffset);
		// back to sunday
		singaporeToday.setUTCDate(singaporeToday.getUTCDate() - singaporeToday.getUTCDay());
		// set to midnight
		singaporeToday.setUTCHours(0,0,0,0);

		var correctDate = new Date();
		// change back to a proper format date (utc = utc)
		correctDate.setTime(singaporeToday.getTime() - singaporeOffset);

		return correctDate;
	}


	function setActiveDate(newDate){
		activeDate = newDate;
		showWeek(activeDate);
	}


	function showWeek(start){
		var endDate = new Date();
		endDate.setTime(start.getTime());
		endDate.setDate(endDate.getDate() + 6);

		var startString = start.getDate() + " " + months[start.getMonth()] + " " + start.getFullYear();
		var endString = endDate.getDate() + " " + months[endDate.getMonth()] + " " + endDate.getFullYear();

		$('#calendar-mobile .mobile-current-week').text(startString + " - " + endString);
	}

	function getWeeklyEvents(start){

		var endDate = new Date();
		endDate.setTime(start.getTime());
		endDate.setDate(endDate.getDate() + 6);
		endDate.setHours(23,59,59,999);

		var url  =  "/events" + (start?("?start=" + Math.floor(start.getTime()/1000) + "&end=" + Math.floor(endDate.getTime()/1000) ):"");


		if(currentRequest){
			currentRequest.abort();
		}

		currentRequest = $.ajax(url).done(function(result){
			
			// result = JSON.parse(result);

			var mobileCal = $('#calendar-mobile .mobile-events');
			// when results are returned, set as active date (prevent mismatched data)
			setActiveDate(start);
			mobileCal.html('');

			if(result.length){

				var currentDay = null;
				result.forEach(function(event){

					if(event.eventDay != currentDay){
						currentDay = event.eventDay;
						var newDay = dayClone.clone(true);
						newDay.find('.mobile-day').text(event.eventDay);
						newDay.find('.mobile-month').text(event.eventMonth);
						newDay.find('.mobile-weekday').text(event.eventDate);
						mobileCal.append(newDay);
					}

					var newClone = eventsClone.clone(true);

					newClone.find('.mobile-title').text(event.title);
					if(event.allDay){
						newClone.find('.mobile-time').text("All Day");
					}
					else{
						if(event.eventStartTime == event.eventEndTime){
							newClone.find('.mobile-time').text(event.eventStartTime);
						}else{
							newClone.find('.mobile-time').text(event.eventStartTime + " - " + event.eventEndTime);
						}
					}


					$('body').append(event.content);

					newClone.click(function(){$('#e_'+event.id).addClass('modal-active');});

					mobileCal.append(newClone);

				});
			}
		});
	}

	function clearEvents(){
		$('#calendar-mobile .mobile-events').html('<div class="loader active"><div class="ball"></div></div>');
	}

	function incrementWeeks(weeks){
		var newDate = new Date();
		newDate.setTime(activeDate.getTime());
		newDate.setDate(newDate.getDate() + (7 * weeks));

		setActiveDate(newDate);
		clearEvents();
		getWeeklyEvents(newDate);
	}


	initMobileCalendar();

// end mobile calendar

$(document).ready(function(){
    $('#event-programme-select').change(function() {
        var url = $('option:selected', this).data('url');
        if (url) {
            window.location = url;
		}
    });
	$("#whats-on-calendar").each(function() {
        var container = $(this);
        var calendarTarget = $('.calendar-target', container);
		var loader = $('.loader', container);
        var events = {};
        var modal = $('#whats-on-modal');

        var showModal = function(dateStr) {
            var date = new Date(dateStr);
            $('.modal-title', modal).text('Events on ' + date.toLocaleDateString());

            var html = '';
            $.each(events[dateStr], function() {
                html += this['html'];
            });
            $('.modal-body', modal).html(html);
            modal.addClass('modal-active');

            if (addtocalendar) {
                addtocalendar.load();
            }
        }

        var formatYmd = function(date) {
            var key = date.getFullYear() + '-';
            var month = '' + (date.getMonth() + 1);
            key += (month.length < 2? '0' : '') + month + '-';
            var day = '' + date.getDate();
            key += (day.length < 2? '0' : '') + day;
            return key;
        }

		var calendar = calendarTarget.flatpickr({
			inline: true,
			enable: [
                function(date) {
                    var key = formatYmd(date);
                    return events && events[key];
                }
			],
            onChange: function(selectedDates, dateStr, instance) {
                showModal(dateStr)
            },
            onMonthChange: function(selectedDates, dateStr, instance) {
                loadEvents(new Date(instance.currentYear, instance.currentMonth, 1));
            },
            onYearChange: function(selectedDates, dateStr, instance) {
                loadEvents(new Date(instance.currentYear, instance.currentMonth, 1));
            }
		});
        $(calendar.calendarContainer).removeClass('arrowTop');

        var request = null;
        var loadEvents = function(startDate) {
            var c = calendar;
            var l = loader;

            l.addClass('active');
            c.redraw();

            if (request) {
                request.abort();
                request = null;
            }

            var endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1);

            request = $.ajax({
                url: '/whats-on',
                data: {
                    start: formatYmd(startDate),
                    end: formatYmd(endDate)
                },
                dataType: 'json'
            })
            .done(function(data, textStatus, jqXHR) {
                $.each(data, function() {
                    var event = this;

					if (!events[event['eventDate']]) {
						events[event['eventDate']] = {};
					}


					events[event['eventDate']][event['id']] = event;

					if ((event['eventEndDate']) != null){
						console.log(event['eventDate']);
						var numdays = moment(event['eventEndDate']).diff(moment(event['eventDate']), 'days');
						// var numdays = 1;
						console.log(numdays);
						for (var i = 0; i < numdays; i++) {
							var newDay = moment(event['eventDate']).add(i + 1, 'days').format('YYYY-MM-DD');

							if (!events[newDay]) {
								events[newDay] = {};
							}
							events[newDay][event['id']] = event;
						}
					}
					// console.log(event);
					// console.log('events', events)
                });
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                if (textStatus == 'abort') {
                    return;
                }
                // alert('Error loading results');
            })
            .always(function() {
                request = null;
                l.removeClass('active');
                c.redraw();
            });
        }
        var now = new Date();
        now.setDate(1);
        loadEvents(now);
	});
});



$(document).ready(function(){
	vegemiteScroll();

    $('.banner iframe').each(function() {
        var iframe = $(this);
        if (iframe.is('[src*="vimeo."]')) {
            var player = new Vimeo.Player(iframe[0]);
            player.setVolume(0);
        } else {
            // Youtube is controlled by the setVolume call onready and plays automatically
        }
    });
});


var lastScroll = 0;
var scrollUp = 0;

$(window).scroll(vegemiteScroll);

function vegemiteScroll(){

    $('.phone-dropdown').removeClass('active');

	var thisScroll = $(this).scrollTop();


	if(!disable_header_scroll){
		scrollUp += lastScroll - thisScroll;

		if(scrollUp > 0)
			scrollUp = 0;
		if(scrollUp < -112)
			scrollUp = -112;
		if(thisScroll <= 0){
			scrollUp = 0;
		}

		$('.navbar-mobile').css('margin-top', scrollUp);
		$('div.mosaic-header-top').css('margin-top', (scrollUp) + 'px');
	}

    var navTopScroll = thisScroll > 100? -100 : (0-thisScroll);
	$('div.navbar-top').css('margin-top', navTopScroll + 'px');

    var next = $('main.main .banner').next();
    $('main.main').toggleClass('main-scrolled', next.length && thisScroll > next.offset().top);

	//$('div.mosaic-header-top').css('margin-top', (thisScroll>118)?-118:(0-thisScroll) + 'px');



	$('.staff-block .staff-item .staff-image.before-scroll').each(function(i, e) {
		if ($(e).offset().top < thisScroll + ( $(window).height() * 0.6) ) {
			$(e).removeClass('before-scroll');
		}
	});



	//if reached bottom, attach sticky cta
	if(thisScroll + $(window).height() > $('footer.footer').offset().top){
		$('.sticky-cta').addClass("stick");
	}else{
		$('.sticky-cta').removeClass("stick");
	}

	hubspotChatPos(thisScroll);

	//if past fold, show back to top and sticky cta
	if(thisScroll > $(window).height()/2){
		$('.sticky-cta').addClass('visible');
	}else{
		$('.sticky-cta').removeClass('visible');
	}


	if(thisScroll > $( document ).height()/2){
		$('.backtotop').addClass("visible");
	}else{
		$('.backtotop').removeClass("visible");
	}



	lastScroll = thisScroll;
}


$('.staff-block .staff-item.has-content .staff-image, .staff-block .staff-item.has-content .staff-details').click(function(){
	$(this).closest('.staff-item').addClass('modal-active');
});

$('.staff-block .staff-item .staff-detail .close').click(function() {
	$(this).closest('.staff-item').removeClass('modal-active');
});

function hubspotChatPos(thisScroll) {

	if (!thisScroll) {
		thisScroll = $(this).scrollTop();
	}

	var $hsChatContainer = $('#hubspot-chat-wrapper');

	// check that hs chat is placed correctly
	if($hsChatContainer.length && $('.sticky-cta').length) {
		var chatOffset = $(window).height() - ($('.sticky-cta').offset().top - thisScroll);
		$hsChatContainer.css('bottom', ((chatOffset>=0)?chatOffset:0) + 'px');
	}
}




$(window).resize(function() {
	if($('.news-items')[0] && $('.news-items')[0].slick){
		$('.news-items')[0].slick.refresh();
	}
	if($('.slides')[0] && $('.slides')[0].slick){
		$('.slides')[0].slick.refresh();
	}
	if($('.hours-slides')[0] && $('.hours-slides')[0].slick){
		$('.hours-slides')[0].slick.refresh();
	}
	draw24lines();
	$(window).scroll();
});


var isIOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);

// this is actually just listening for .chat-btn click
$('.sticky-cta div').click(function(){
	$('.sticky-cta div').not(this).removeClass('active');
	$(this).toggleClass("active");
	$(this).trigger('toggle-active');
    $('.sticky-cta').removeClass('stick-important');

	if($('.sticky-cta div.active').length){
		$('.sticky-cta').addClass('one-active');

        if(isIOS && $(this).find('.stickyform').length){
            $('.sticky-cta').addClass('stick-important');
            $(window).scrollTop($('.sticky-cta').offset().top - $(window).height() + 20);
        }else{
        }
	}
	else{
		$('.sticky-cta').removeClass('one-active')
	}

});

$('.sticky-cta form input').focus(function(){
	$(this).parent().parent().find('label').addClass('mini');
});

$('.sticky-cta form textarea').focus(function(){
	$(this).parent().parent().find('label').addClass('mini');
});

$('.text-expand').click(function(){
	$(this).closest('.text-content').toggleClass("active");
});

$('.slide-expand').click(function(){
	$(this).closest('.slide').toggleClass("active");
});

$('.infotext-expand').click(function(){
	$(this).closest('.expandable-item').toggleClass('active');
});

$('.universities-block .region').click(function(){
	$(this).toggleClass('active');
});

$('.expandable-forms .form').click(function(){

	var jthis = $(this);

	// reset any other forms
	$('.expandable-forms .form').not(this).removeClass('active');
	$('.hiddenform').not('#' + jthis.attr('data-form-id')).removeClass('active');

	// toggle this one
	jthis.toggleClass('active');
	$('#' + jthis.attr('data-form-id') ).toggleClass('active');
});

$('.step .content .step-circle').click(function(){
	$(this).closest('.content').toggleClass('active');
	$(this).closest('.step').find('.details').toggleClass('active');
});

$('.slides, .mosaic-slides').on('beforeChange', function(e, slick, slide){

	// remove active from all slides
	$(e.target).find('.slide').removeClass('active');


	var thisslide = $(slick.$slides.get(slide));




	// pause current video
	var video = thisslide.find('.slide-video iframe.vimeo');
	if(video.length) new Vimeo.Player(video).pause();

	var ytvideo = thisslide.find('.slide-video iframe.ytplayer')
	if(ytvideo.length && ytvideo[0].ytplayer) ytvideo[0].ytplayer.pauseVideo();

});

$('.slide-next').click(function(){

	var video = $(this).closest('.slide').find('.slide-video iframe.vimeo');
	if(video.length) new Vimeo.Player(video).pause();

	var ytvideo = $(this).closest('.slide').find('.slide-video iframe.ytplayer')
	if(ytvideo.length && ytvideo[0].ytplayer) ytvideo[0].ytplayer.pauseVideo();

	if($(this).closest('.slide').hasClass('slick-current')){
		$(this).closest('.slides, .mosaic-slides, .hours-slides').slick('slickNext');
	}
});

$('.slide-prev').click(function(){

	var video = $(this).closest('.slide').find('.slide-video iframe.vimeo');
	if(video.length) new Vimeo.Player(video).pause();

	var ytvideo = $(this).closest('.slide').find('.slide-video iframe.ytplayer')
	if(ytvideo.length && ytvideo[0].ytplayer) ytvideo[0].ytplayer.pauseVideo();

	if($(this).closest('.slide').hasClass('slick-current')){
		$(this).closest('.slides, .mosaic-slides, .hours-slides').slick('slickPrev');
	}
});

$('.video-overlay').click(function(){

	var overlay = $(this);
	var svid = overlay.closest('.slide').find('.slide-video');
	var video = svid.find('iframe.vimeo');
	var slick = overlay.closest('.slides, .mosaic-slides');

	if(video.length){
		var player = new Vimeo.Player(video);
		player.play();
		player.on('pause', function(){
			svid.removeClass("active");
			overlay.removeClass("hidden");
			slick.slick('slickPlay');
		});
		player.on('play', function(){
			slick.slick('slickPause');
		});
	}
	else{
		// this is doing the same as vimeo code above. yt api is bad.
		var ytvideo = svid.find('iframe.ytplayer');
		if(ytvideo.length){
			var elem = ytvideo[0];
			if(elem.ytplayer){
				elem.ytplayer.playVideo();
			}else{
				// write ytplayer directly to element for easy management
				elem.ytplayer = new YT.Player(elem,
					{
						events:{
							'onReady': function(e){
								elem.ytplayer.playVideo();
							},
							'onStateChange': function(e){
								if(e.data == 0 || e.data == 2){
									svid.removeClass('active');
									overlay.removeClass('hidden');
									slick.slick('slickPlay');
								}else if(e.data == 1){
									slick.slick('slickPause');
								}
							}
						}
					}
				);
			}
		}
	}

	svid.addClass("active");
	overlay.addClass("hidden");
});

$('.article-reply form').submit(function(e){

	e.preventDefault();

	var form = $(this);
	var name = form.find('input.name');
	var email = form.find('input.email');
	var comment = form.find('textarea.comment');
	var error = false;
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

	$('.nameerror, .emailerror, .commenterror').removeClass('show');
	if(name.val() == null || name.val() == ""){
		$('.nameerror').addClass('show');
		error = true;
	}
	if(email.val() == null || email.val() == "" || !regex.test(email.val())){
		$('.emailerror').addClass('show');
		error = true;
	}
	if(comment.val() == null || comment.val() == "" ){
		$('.commenterror').addClass('show');
		error = true;
	}
	if(!error){
		$('.article-reply').addClass('loading');
		form.ajaxSubmit({
			success: function(){
				$('.article-reply').removeClass('loading');
				$('.article-reply').addClass('posted');
				var newcomment = $('.blank-comment');
				newcomment.addClass('show');
				newcomment.find('.user-name').text(name.val());
				newcomment.find('.comment-text').text(comment.val());
			}
		});
	}
});


$('.nav-toggle, .mobile-overlay').click(function(){
	$('.nav-toggle').toggleClass('active');
	$('.navbar-bottom').toggleClass('active');
	$('main.main').toggleClass('nav-active');
	$('header.header').toggleClass('nav-active');
	$('footer.footer').toggleClass('nav-active');
	$('div.sticky-cta').toggleClass('nav-active');
});


var disable_header_scroll = false;

$('.backtotop').click(function(){

	disable_header_scroll = true;

	//$('main.main :first-child').offset().top
	$('html,body').animate({ scrollTop: 0 }, 'slow', 'swing', function(){
		disable_header_scroll = false;
	});
})

$('.navbar-pages .parent > a .expander').click(function(e){
	var a = $(this).closest('a');
	var parent = a.closest('.parent');
	var children = parent.find('.children');

	if(parent.closest('.navbar-bottom').hasClass('active') && children.children().length > 0 ){
		e.preventDefault();
		a.toggleClass('expand');
		children.toggleClass('active');
	}
});


$('.navbar-pages .parent > a:not(.home)').click(function(e){

		e.preventDefault();

		var a = $(this).closest('a');
		var parent = a.closest('.parent');
		var children = parent.find('.children');


		if(window.matchMedia("only screen and (min-width: 992px)").matches){
			$('.navbar-pages .parent').not(parent).removeClass('active');
			$('.navbar-pages .parent .children, .navbar-links .navbar-dropdown').not(children).removeClass('active');
		}

		children.toggleClass('active');
		parent.toggleClass('active');

});

$('.navbar-links .navbar-link > a').click(function(e){
	var children = $(this).closest('span').find('.navbar-dropdown');
	if (children.length) {
		e.preventDefault();
	}
	if(window.matchMedia("only screen and (min-width: 992px)").matches){
		$('.navbar-pages .parent .children, .navbar-links .navbar-dropdown').not(children).removeClass('active');
	}
	children.toggleClass('active');
});

$('.header.navbar').on('mouseleave',function(e){
	if(window.matchMedia("only screen and (min-width: 992px)").matches){
		$('.navbar-pages .parent').removeClass('active');
		$('.navbar-pages .parent .children').removeClass('active');
	}
});


$('.virtual-tour .location .location-name').click(function(){

	var location = $(this).closest('.location');

	$('.virtual-tour .location').not(location).removeClass('active');
	location.toggleClass('active');

});

$('.virtual-tour .sublocation .sublocation-name').click(function(){

	var streetview = decodeURIComponent($(this).attr("data-street-view-code"));
	$(this).closest('.virtual-tour').find('.street-view').html(streetview);
	$('.virtual-tour .sublocation-name').removeClass('active');
	$(this).addClass('active');
});



$('a.search.search-btn').click(function(){
	$('.floating-searchbox').toggleClass('active');
	$('.floating-searchbox input').focus();
});

$('a.search.search-mobile-btn').click(function(){
	$('.floating-mobile-searchbox').toggleClass('active');
	$('.floating-mobile-searchbox input').focus();
});

$('.phone-dropdown .dropdown-link').click(function(){
    $(this).closest('.phone-dropdown').toggleClass('active');
});

$('html,body').click(function(e){
    if(!$(e.target).hasClass('dropdown-link')){
        $('.phone-dropdown').removeClass('active');
    }
});

$('.expandable-slides').slick({
    arrows: false,
    adaptiveHeight: true
});

$('.expandable-slide .slide-expand').click(function(){
    $(this).closest('.expandable-slide').toggleClass('expanded');
    $(this).closest('.expandable-slides').slick('animateHeight');
});

$('.expandable-slide .seemore').click(function(){
    $(this).closest('.expandable-slides').slick('slickNext')
});

$('.slide-video[data-modal-id], .thumb-video[data-modal-id]').click(function(e) {
	e.preventDefault();
	$('#' + $(this).data('modal-id')).addClass('modal-active');
});


var favourites = [];

function loadFavourites(){
	favourites = Cookies.getJSON('favourites');
	if(favourites == null){
		favourites = [];
	}

	$('.favourite-page-button').removeClass('is-favourite');

	// probably do this in craft first
	$.each(favourites, function(index, value){
		if(window.location.pathname.substr(1) == value){
			$('a.favourite-button').addClass('is-favourite');
		}

		if(value == ""){
			value = "__home__";
		}
		//update favourites page items
		$('.favourite-page-button[data-fav-uri="'+value+'"]').addClass('is-favourite');
	});
}


loadFavourites();

//Cookies.set('favourites', []);

$('a.favourite-button').click(function(){

	loadFavourites();

	var wasfav = false;
	$.each(favourites, function(index, value){
		//update current page
		if(window.location.pathname.substr(1) == value){
			$('a.favourite-button').removeClass('is-favourite');
			wasfav = true;
			favourites.splice(index, 1);
		}


	});

	if(!wasfav){
		favourites.push(window.location.pathname.substr(1));
		$('a.favourite-button').addClass('is-favourite');
	}

	Cookies.set('favourites', favourites);
});


$('a.favourite-page-button').click(function(){



	var button = $(this);

	var uri = button.attr('data-fav-uri');

	if(uri == "__home__"){
		uri = "";
	}

	loadFavourites();

	var wasfav = false;
	$.each(favourites, function(index, value){
		if(uri == value){
			button.removeClass('is-favourite');
			wasfav = true;
			favourites.splice(index, 1);
		}
	});

	if(!wasfav){

		favourites.push(uri);
		button.addClass('is-favourite');
	}

	Cookies.set('favourites', favourites);

});

if(typeof applicationFormPosition !== 'undefined' && ($('form.form--academicPosition').length ) || $('form.form--applicationForm').length ){
	$('form.form--academicPosition input[name$="[fields][positionAppliedFor]"]').val(applicationFormPosition);
	$('form.form--applicationForm input[name$="fields[positionAppliedFor]"]').val(applicationFormPosition);
}



// pointless lines

function calcangle(cx, cy, ex, ey) {
  var dy = ey - cy;
  var dx = ex - cx;
  var theta = Math.atan2(dy, dx); // range (-PI, PI]
  theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
  //if (theta < 0) theta = 360 + theta; // range [0, 360)
  return theta;
}

function drawlines(){
	$('.line-block .block:not(:last-child)').each(function(){

		// position lines relative to document

		var el = $(this);

		var round = el.find('.btn-round');
		var pos = round.position();
		var width = round.width() / 2;

		var nextround = el.closest('.block').next().find('.btn-round');
		var nextwidth = nextround.width() / 2;

		var line = el.closest('.block').find('.magic-line');

		var angle = calcangle(round.offset().top+width, round.offset().left, nextround.offset().top+nextwidth, nextround.offset().left);

		line.css("top",pos.top + width);
		line.css("left",pos.left + width);
		line.css("width", nextround.offset().left - round.offset().left + "px");
		line.css("transform-origin", "0% 0%");
		line.css("transform", "rotate(" + (90 -  angle) + "deg)");

	});
}

drawlines();


function draw24lines(){
	$('.hours-slides .slide').each(function(){


		// due to slick doing crazy things lines are simply stuck to each slide,
		// there are two lines per slide, and we calculate the angles based on the width of slide
		// if the calculations are correct it should appear as though the lines are continuous

		var el = $(this);

		var circle = el.find('.time-circle');


		var pos = circle.position();
		var width = circle.width() / 2;

		var prevcircle = el.prev().find('.time-circle');
		//if(!prevcircle.length) prevcircle = el.closest('.hours-slides').last('slide');


		var nextcircle = el.next().find('.time-circle');
		//if(!nextcircle.length) nextcircle = el.closest('.hours-slides').first('slide');

		var prevwidth = prevcircle.width() / 2;
		var nextwidth = nextcircle.width() / 2;


		var slidewidth = el.closest('.slide').width();

		var lineleft = el.closest('.slide').find('.line-left');
		var lineright = el.closest('.slide').find('.line-right');



		if(prevcircle.length){

			var leftangle = calcangle(prevcircle.position().top+prevwidth,prevcircle.position().left +width, circle.position().top+width, circle.position().left+width + slidewidth);
			lineleft.css("position", "absolute");
			lineleft.css("top", pos.top + width);
			lineleft.css("right",slidewidth - pos.left - width + "px");
			lineleft.css("width", slidewidth + "px"); // not really adequet length calc
			lineleft.css("transform-origin", "100% 100%");
			lineleft.css("transform", "rotate(" + (90 -  leftangle) + "deg)");
		}

		if(nextcircle.length){
			var rightangle = calcangle(circle.position().top+width, circle.position().left+width, nextcircle.position().top+nextwidth, nextcircle.position().left + width + slidewidth);
			lineright.css("position", "absolute");
			lineright.css("top", pos.top + width);
			lineright.css("left",pos.left + width);
			lineright.css("width", slidewidth + "px"); // not really adequet length calc
			lineright.css("transform-origin", "0% 0%");
			lineright.css("transform", "rotate(" + (90 -  rightangle) + "deg)");
		}

	});
}


draw24lines();

$(window).resize(drawlines);




$('.js-load-articles-button').click(function() {
	var $button = $(this);
	var $controls = $button.closest('.js-load-articles-controls');
	var $list = $controls.closest('.js-load-articles').find('.js-load-articles-list');
	var category = $list.data('category');
	var limit = $list.data('limit');
	var offset = $list.data('offset');
	$controls.addClass('loading');
	$.ajax("/api/mosaic-category", {
		data: {
			'category': category,
			'limit': limit,
			'offset': offset,
		}
	}).done(function(result) {
		$list.append(result);
		$list.data('offset', offset + limit);
		$controls.removeClass('loading');
		if (!result.length) {
			$controls.addClass('end');
		}
		initSlickMosaicGalleries();
		getMosaicViews();
	});
});

function initSlickMosaicGalleries() {
	$('.media-gallery-slider').not('.slick-initialized').slick({
		arrows: true,
		dots: true,
		autoplay: false,
		  adaptiveHeight: true,
		  lazyLoad: 'ondemand',
		  prevArrow: '<button class="slick-arrow slick-prev"><svg class="circle circle-arrow arrow-left" viewbox="0 0 32 32"><use xlink:href="#arrow"></use></svg></button>',
		  nextArrow: '<button class="slick-arrow slick-next"><svg class="circle circle-arrow" viewbox="0 0 32 32"><use xlink:href="#arrow"></use></svg></button>'
	});
}

$('.media-galleries-slider').not('.slick-initialized').slick({
	arrows: true,
	dots: true,
	autoplay: false,
	  prevArrow: '<button class="slick-arrow slick-prev"><svg class="circle circle-arrow arrow-left" viewbox="0 0 32 32"><use xlink:href="#arrow"></use></svg></button>',
	  nextArrow: '<button class="slick-arrow slick-next"><svg class="circle circle-arrow" viewbox="0 0 32 32"><use xlink:href="#arrow"></use></svg></button>'
});


function getMosaicViews() {
	$('.gallery-info:not(.has-views)').each(function(i,e) {
		var $details = $(e);
		$.ajax('/api/analytics.php', {
			data: {
				'slug': $details.data('article-slug')
			}
		}).done(function(result) {
			var count = result.reports[0].data.totals[0].values[0];
			$details.find('.view-count').prepend(count);
			$details.addClass('has-views');
		});
	});
}

initSlickMosaicGalleries();
getMosaicViews();


function toggleForm() {
	$('.toggleForm').click(function(e){
		e.preventDefault();
		var formTarget = $(this).closest('.layout-panel').find('.form-wrapper');

		if (!$(formTarget).hasClass("show")) {
			formTarget.addClass('show');
		}
		if ($(formTarget).hasClass("show")) {
			$("body,html").animate(
		      {
		        scrollTop: formTarget.offset().top - 100
		      },
		      800
		    );
		}
	});
	$('.toggleFormNo').click(function(e){
		e.preventDefault();
		index = $(this).data('toggle');
		var formTarget = $(this).closest('.layout-panel').find('#' + index);

		if (!$(formTarget).hasClass("show")) {
			$(this).closest('.layout-panel').find('.form-wrapper').removeClass('show');
			formTarget.addClass('show');
		}
		if ($(formTarget).hasClass("show")) {
			$("body,html").animate(
		      {
		        scrollTop: formTarget.offset().top - 100
		      },
		      800
		    );
		}
	});

	$('.form-wrapper .close button').click(function(e){
		e.preventDefault();
		var formTarget = $(this).closest('.form-wrapper').removeClass('show');
	});
}

$(document).ready(function(){
	toggleForm();
	faqaccordion();
});

function faqaccordion() {

	$(".accordion-head").on("click", function () {
		$(this).children(".accordion-arrow").toggleClass("active");
		// $(".accordion-arrow").not($(this).children(".accordion-arrow")).removeClass("active");
		$(this).next().slideToggle(300);
		// $(".acc-body").not($(this).next()).slideUp("fast");
		//Scroll to top for each accordion that is clicked.
		// The "180" is the distance from top. The "300" is the scroll speed. The "400" is for the animation delay depending on inner content length.
		setTimeout(() => {
			$("html").animate({ scrollTop: $(this).offset().top - 180 }, 300);
		}, 100);
	});

}


function initEventMaps () {
    digistormWeb.maps();
}